import patientReducer from './reducers';
import * as allPatientActions from './actions';

export { default as patientOperations } from './operations';
export { default as patientTypes } from './types';
export const patientActions = allPatientActions;
export default patientReducer;
